<template>
  <employee-profile>
    <template v-slot:head>
      <button
        class="work-place-page__buttons-add"
        type="button"
        v-on:click="onShowWorkPlaceDialog">
        Добавить рабочее место
      </button>
    </template>
    <div class="work-place-table">
      <form class="work-place-table__head">
        <div class="work-place-table__cell">№</div>
        <div class="work-place-table__cell">Филиал</div>
        <div class="work-place-table__cell">Основной филиал</div>
        <div class="work-place-table__cell" />
      </form>
      <div
        class="work-place-table__body"
        v-bind:key="workPlaceTableKey"
        v-if="!isEmptyWorkPlaceList && !isAwaitRequest"
      >
        <div
          class="work-place-table__row"
          v-for="({
            id,
            name,
            is_main,
            actions,
          }, index) in workPlaceList"
          v-bind:key="id">
          <div
            data-label="№"
            class="work-place-table__cell number">
            {{ index + 1 }}
          </div>
          <div
            class="work-place-table__cell name"
            data-label="Филиал">
            {{ name }}
          </div>
          <div class="work-place-table__cell">
            <input-checkbox
              v-bind:disabled="is_main"
              v-bind:value="is_main"
              v-on:input="onChangeMainWorkPlace(name, id)"
            />
          </div>
          <div
            data-label="Уволить"
            class="work-place-table__cell"
          >
            <button
              v-if="!is_main && hasDismissAction(actions)"
              class="work-place-table__icon-remove"
              type="button"
              title="Уволить из филиала"
              v-on:click="onShowDismissedModalDialog(name, id)" />
          </div>
        </div>
      </div>
      <div
        v-else
        class="work-place-table__message"
      >
        Ничего не найдено
      </div>
    </div>
    <modal-dialog
      v-bind:title="dismissDialogTitle"
      v-model="shownDismissedModalDialog"
      content-class="work-place-modal"
      title-center
      max-width="480"
      with-cross
    >
      <template>
        <div class="work-place-modal__date">
          <div class="work-place-modal__date__label">Дата увольнения</div>
          <v-menu min-width="auto">
            <template v-slot:activator="{ on }">
              <div>
                <button
                  class="work-place-modal__date__activator"
                  title="Сменить дату"
                  type="button"
                  v-on="on"> {{ dismissedDateText }}</button>
              </div>
            </template>
            <v-date-picker
              first-day-of-week="1"
              color="#0489E0"
              locale="ru-ru"
              no-title
              v-bind:allowed-dates="allowedDates"
              v-model="dismissedDate"
            />
          </v-menu>
        </div>
        <div class="work-place-modal__buttons">
          <button
            class="work-place-modal__button"
            type="button"
            v-on:click="onCloseDismissedModalDialog"
          >
            Отменить
          </button>
          <button
            class="work-place-modal__button negative"
            type="button"
            v-on:click="dismissEmployeeOnWorkPlace"
          >
            Уволить
          </button>
        </div>
      </template>
    </modal-dialog>
    <side-slide-transition>
      <confirm-side-dialog
        class="workplace-side-dialog"
        label="Добавление рабочего места"
        v-if="shownPlaceWorkDialog"
        v-on:cancel="onClosePlaceWorkDialog">
        <form class="workplace-form" v-on:submit.prevent="onAddPlaceWork">
          <autocomplete-input
            item-text="title"
            item-value="value"
            label="Филиал"
            required="required"
            v-bind:items="branchedClinics"
            v-model="selectedBranchClinic"
          />
          <div class="workplace-form__buttons">
            <button
              class="workplace-form__button-cancel"
              type="button"
              v-on:click="onClosePlaceWorkDialog"
            >Отменить</button>
            <button
              class="workplace-form__button-save"
              type="submit"
            >Сохранить</button>
          </div>
        </form>
      </confirm-side-dialog>
    </side-slide-transition>
  </employee-profile>
</template>

<script>
import EmployeeProfile from '@/views/ClinicPanel/EmployeeProfile.vue';
import notifierMixin from '@/mixins/notifierMixin';
import InputCheckbox from '@/components/InputCheckbox.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import dateMixin, { getISODateStringByDate } from '@/mixins/dateMixin';

/**
 * @description Компонент пункта профиля сотрудника "Основное".
 * @type {Vue}
 */
export default {
  components: {
    ModalDialog,
    AutocompleteInput,
    ConfirmSideDialog,
    SideSlideTransition,
    InputCheckbox,
    EmployeeProfile,
  },
  computed: {
    /**
     * @description Дата увольнения сотрудника.
     * @type {string}
     */
    dismissedDateText() {
      if (this.dismissedDate) {
        return this.getFullDate(this.dismissedDate);
      }
      return 'Укажите дату';
    },
    /**
     * @description Разрешено изменение основного рабочего места.
     * @returns {boolean}
     */
    hasChangeMainWorkPlace() {
      return this.actions.includes('change-main-work-place');
    },
    /**
     * @description Идентификатор сотрудника.
     * @param vm
     * @returns {number}
     */
    employeeId: (vm) => parseInt(vm.$route.params.id, 10),
    /**
     * @description Список рабочих мест пуст.
     * @returns {boolean}
     */
    isEmptyWorkPlaceList() {
      return !this.workPlaceList.length;
    },
  },
  created() {
    this.fetchFillers();
    this.fetchWorkPlaces();
  },
  currentDate: getISODateStringByDate(new Date()),
  data() {
    return {
      /**
       * @description Разрешения.
       * @type {array}
       */
      actions: [],
      /**
       * @description Клиники филиалы.
       * @type {array}
       */
      branchedClinics: [],
      /**
       * @description Дата увольнения.
       * @type {string}
       */
      dismissedDate: '',
      /**
       * @description Заголовок модального окна увольнения.
       * @type {string}
       */
      dismissDialogTitle: '',
      /**
       * @description Список рабочих мест.
       * @type {array}
       */
      workPlaceList: [],
      /**
       * @description Ожидание конца запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Выбранный филиал.
       * @type {Number|null}
       */
      selectedBranchClinic: null,
      /**
       * @description Идентификатор выбранного филиала.
       * @type {null|number}
       */
      selectedBranchId: null,
      /**
       * @description Отобразить окно увольнения.
       * @type {boolean}
       */
      shownDismissedModalDialog: false,
      /**
       * @description Отобразить окно рабочего места.
       * @type {boolean}
       */
      shownPlaceWorkDialog: false,
      /**
       * @description Ключ таблице рабочих мест.
       * @type {number}
       */
      workPlaceTableKey: 0,
    };
  },
  methods: {
    /**
     * @description Функция описывающая условие доступности выбора дат в datepicker
     * @param {string} candidate Строка с датой в формате Y-m-d
     * @return {boolean}
     */
    allowedDates(candidate) {
      return candidate <= this.$options.currentDate;
    },
    /**
     * @description Уволить сотрудника в выбранном филиале.
     * @returns {void}
     */
    dismissEmployeeOnWorkPlace() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = async (title) => {
        this.notifySuccess(title);
        this.fetchWorkPlaces();
        this.onCloseDismissedModalDialog();
      };
      const response = this
        .$employeeGateway
        .dismissOnWorkPlace(
          this.employeeId,
          this.dismissedDate,
          this.selectedBranchId,
        );
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить заполнители.
     * @returns {void}
     */
    fetchFillers() {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = async ({ branchedClinics }) => {
        this.branchedClinics = branchedClinics;
      };
      const response = this.$employeeGateway.fetchWorkPlaceFillers(this.employeeId);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить список рабочих мест.
     * @returns {void}
     */
    fetchWorkPlaces() {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = async ({ workPlaces, actions }) => {
        this.workPlaceList = workPlaces;
        this.actions = actions;
      };
      const response = this.$employeeGateway.fetchWorkPlaces(this.employeeId);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать добавление рабочего места.
     * @returns {void}
     */
    onAddPlaceWork() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = async (response) => {
        this.fetchFillers();
        this.fetchWorkPlaces();
        this.onClosePlaceWorkDialog();
        this.notifySuccess(response.title);
      };
      const response = this
        .$employeeGateway
        .addNewWorkPlace(this.employeeId, this.selectedBranchClinic);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать закрытие окна рабочего места.
     * @returns {void}
     */
    onClosePlaceWorkDialog() {
      this.shownPlaceWorkDialog = false;
      this.selectedBranchClinic = null;
    },
    /**
     * @description Обработать изменение основного места работы.
     * @param {string} name
     * @param {number} id
     * @returns {void}
     */
    async onChangeMainWorkPlace(name, id) {
      if (this.hasChangeMainWorkPlace !== true) {
        this.notifyFail(
          'Изменить основное рабочее место сотрудника невозможно.'
          + ' Обратитесь к рабочему персоналу, основного филиала сотрудника',
        );
        this.workPlaceTableKey += 1;
        return;
      }
      const dialog = await this.showAcceptDialog(`Вы действительно хотите установить ${name} основным?`);
      if (dialog.result !== DialogResult.YES) {
        this.workPlaceTableKey += 1;
        return;
      }
      const onFail = (error) => {
        this.workPlaceTableKey += 1;
        this.notifyFail(error.getTitle());
      };
      const onSuccess = async (response) => {
        this.fetchWorkPlaces();
        this.notifySuccess(response.title);
      };
      const response = this
        .$employeeGateway
        .changeMainWorkPlace(this.employeeId, id);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать показ диалогового окна рабочего места.
     * @returns {void}
     */
    onShowWorkPlaceDialog() {
      this.shownPlaceWorkDialog = true;
    },
    /**
     * @description Имеется разрешение на увольнение.
     * @param {Array} actions
     * @returns {boolean}
     */
    hasDismissAction(actions) {
      return actions.includes('dismiss');
    },
    /**
     * @description Обработать событие показа модального окна увольнения.
     * @param {string} branchName
     * @param {number} branchId
     * @returns {void}
     */
    onShowDismissedModalDialog(branchName, branchId) {
      this.dismissDialogTitle = `Сотрудник будет уволен из филиала ${branchName}`;
      this.dismissedDate = '';
      this.selectedBranchId = branchId;
      this.shownDismissedModalDialog = true;
    },
    /**
     * @description Обработать событие закрытия модального окна увольнения.
     * @returns {void}
     */
    onCloseDismissedModalDialog() {
      this.selectedBranchId = null;
      this.shownDismissedModalDialog = false;
    },
  },
  mixins: [
    notifierMixin,
    builtInDialogMixin,
    dateMixin,
  ],
  name: 'ClinicPanelEmployeeProfileWorkPlace',
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.work-place-modal {
  &__date {
    justify-self: center;
    width: min(100%, 310px);
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90A0B7;
      margin: 0 0 3px 0;
    }
    &__activator {
      width: 100%;
      padding: 10px 50px 10px 10px;
      font-size: 16px;
      text-align: left;
      border: 1px solid #C2CFE0;
      border-radius: 4px;
      background-image: url("@/assets/img/calendar-grey.svg");
      background-position: right 10px center;
    }
  }
  &__buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding-block: 10px;
  }
  &__button {
    @include buttons.btn-transparent(fit-content, 2rem, 1rem);
    min-width: 150px;
    padding: 0 10px;
    &.negative {
      border: 1px solid rgba(224, 4, 4, 0.97);
      color: rgba(224, 4, 4, 0.97);
    }
  }
}

.workplace-form {
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    width: min(100%, 438px);
    margin: 30px 0 0 auto;
  }
  &__button {
    &-cancel {
      @include buttons.btn-transparent(100%, 3rem, 1rem);
    }
    &-save {
      @include buttons.btn-blue(100%, 3rem, 1rem);
    }
  }
}

.work-place {
  &-page {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    &__buttons {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      width: 100%;
      column-gap: 10px;
      align-items: center;
      &-add {
        @include buttons.btn-blue(100%, 48px, 16px);
        @include buttons.btn-blue-add(19px);
        max-width: 256px;
      }
    }
    &__row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-block: 37px 10px;
    }
  }
  &-table {
    counter-reset: counterEmployees;
    margin: 25px 0 0 0;
    padding-bottom: 52px;
    overflow: hidden;
    overflow-x: auto;
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 60px minmax(200px, 0.5fr) minmax(200px, 1fr) 40px;
      align-items: center;
      min-width: 500px;
      font-size: 14px;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__body {
      max-height: 100%;
      overflow-y: auto;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 0;
      &:hover {
        background: #eaeff3;
      }
    }
    &__cell {
      padding: 12px 8px;
      transition: color var(--animate-duration);
      overflow: hidden;
      &.sort {
        text-align: left;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:after {
          content: '';
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          width: 10px;
          height: 10px;
          margin: 0 0 0 5px;
        }
        &:hover {
          text-decoration: none;
        }
        &.selected {
          color: var(--action-color);
        }
      }
      .theme--light.v-icon:focus:after {
        opacity: 0;
      }
      &.name {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        text-align: left;
        button:first-child {
          text-align: left;
        }
      }
      &.success,
      &.fail,
      &.none {
        display: flex;
        align-items: center;
      }
      &.success:before,
      &.fail:before,
      &.none:before {
        content: '';
        height: 20px;
        margin-right: 10px;
        width: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
      &.success {
        background: #E4FFEC !important;
        &:before {
          background-image: url("@/assets/img/checked/all-checked-green.svg");
        }
      }
      &.fail {
        background: #FFECEC;
        &:before {
          background-image: url("@/assets/img/exit-red.svg");
        }
      }
      &.none:before {
        height: 6px;
        width: 6px;
        background: #ABB1A3;
        border-radius: 50%;
        margin: 0 10px 0 6px;
      }
    }
    &__message {
      text-align: center;
      padding-top: 40px;
      font-size: 24px;
    }
    &__icon {
      &-remove {
        display: block;
        width: 12px;
        height: 12px;
        padding: 0;
        margin: 0 auto;
        background-image: url("@/assets/img/exit-grey.svg");
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: contain;
        cursor: pointer;
        &:hover {
          background-image: url("@/assets/img/exit-blue.svg");
        }
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .work-place-table {
    padding: 0;
    &__body {
      overflow-y: visible;
    }
  }
}

</style>
